import React, {useEffect, useMemo, useRef, useState} from 'react';
//import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import axios from 'axios';
import { api } from "../../app/http-common";
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';
import SearchFields from './../CreateBrief/SearchFields';
import './Stories.css';
import {useDispatch, useSelector} from "react-redux";
import {selectSearchParams, selectSelectedClaimsArray, selectSelectedStoriesArray} from "../../app/store";
import {
    extractKeywords,
    normalThemes,
    formatDate,
    getLanguageName,
    getSearchTitle,
    languages
} from "../CreateBrief/transformers";
import ColumnView from "../CreateBrief/ColumnView";
import {
    clearSelectedStoriesArray,
    setSelectedArticlesArray,
    setSelectedLanguages,
    setSelectedStoriesArray
} from "../CreateBrief/slice";
import { useCanEdit } from '../../hooks/useFrontegg';

// Fix for default icon issue with Webpack
delete L.Icon.Default.prototype._getIconUrl;

L.Icon.Default.mergeOptions({
    iconRetinaUrl: 'https://unpkg.com/leaflet@1.7.1/dist/images/marker-icon-2x.png',
    iconUrl: 'https://unpkg.com/leaflet@1.7.1/dist/images/marker-icon.png',
    shadowUrl: 'https://unpkg.com/leaflet@1.7.1/dist/images/marker-shadow.png',
});

const Stories = ({stories, errorStrories,handleExpandStory,sortBy,handleMergeStories,isLoading,onLoadMore,hasMoreStories,isLoadingMore,expandedTimeRange}) => {
    const canEdit = useCanEdit();
    const dispatch = useDispatch();
    const [expandedStory, setExpandedStory] = useState(null);
    const [expandedArticle, setExpandedArticle] = useState(null);
    const [storyClaims, setStoryClaims] = useState({});
    const [claims, setClaims] = useState({});
    const [coordinatesCache, setCoordinatesCache] = useState({});
    const [storyCoordinates, setStoryCoordinates] = useState({});
    const { keywords, dateRange, selectedCategories ,selectedTimeRange,selectedLanguages} = useSelector(selectSearchParams);
    const [storiesTitle, setStoriesTitle] = useState(null);
    const selectedStories = useSelector(selectSelectedStoriesArray);
    const previousTitleRef = useRef('');
    const [animationKey, setAnimationKey] = useState(0);
    const [alreadyDoneStoriesIds, setAlreadyDoneStoriesIds] = useState([]);
    // Toast notification state
    const [showToast, setShowToast] = useState(false);
    const [toastMessage, setToastMessage] = useState('');
    const [toastType, setToastType] = useState('success');

    // Toast notification function
    const showToastNotification = (message, type = 'success') => {
        setToastMessage(message);
        setToastType(type);
        setShowToast(true);
        setTimeout(() => {
            setShowToast(false);
        }, 3000);
    };


    useEffect(() => {
        let keywords_;
        if (keywords) {
             keywords_ = extractKeywords(keywords);
        }
        const lans = selectedLanguages.length === languages.length ? 'All languages' : selectedLanguages;
        const title = getSearchTitle(keywords_,selectedCategories,selectedTimeRange,lans,true)
        setStoriesTitle(title);
    }, [stories]);

    // Derive storiesList synchronously from stories prop via useMemo.
    // Previously used useState + useEffect which caused a render gap where
    // storiesList was null on remount, showing "No stories found" flash.
    const storiesList = useMemo(() => {
        let list = stories
            .filter(story => story.groupSubject && story.groupSubject._id)
            .map(story=>{
            const title = story.title || story.groupSubject?.title;
            const type ='story';
            const totalArticleCount = story.totalArticleCount || story.articleCount || story.groupSubject?.articleCount;
            const matchedArticleCount = story.matchedArticleCount || (story.articles || []).length;
            const articles = (story.articles || []).map(article => ({
                ...article,
                storyTitle: title
            }));
            const languages = [...new Set(story.languageNames || (story.languagesCodes || []).map(getLanguageName))].join(', ')
            return {title,
                    type,
                articleCount: totalArticleCount,
                totalArticleCount,
                matchedArticleCount,
                articles,
                _id:story.groupSubject._id,
                slug: story.groupSubject?.slug,
                earliest: story.earliest,
                recent:story.recent,
                languages,
                excerpt: story.excerpt,
                maxRanking: story.maxRanking,
                dominantSentiment: story.dominantSentiment,
                totalShares: story.totalShares,
                articlesWithRanking: story.articlesWithRanking,
                feedSources: story.feedSources}
        })

        if (sortBy === 'recent') {
            list.sort((a, b) => new Date(b.recent) - new Date(a.recent));
        }
        return list;
    }, [stories, sortBy]);

    // Handle Live mode animation when the top story changes (side effect, separate from useMemo)
    useEffect(() => {
        if (sortBy === 'recent' && storiesList.length && previousTitleRef.current !== storiesList[0].title) {
            setAnimationKey(prevKey => prevKey + 1);
            previousTitleRef.current = storiesList[0].title;
        }
    }, [storiesList, sortBy]);

    // Fetch already done stories only once when component mounts
    useEffect(() => {
        try {
            const fetchAlreadyDoneStories = async () => {
                const response = await api.getAlreadyDoneStories();
                setAlreadyDoneStoriesIds(response);
            }
            fetchAlreadyDoneStories();
        }
        catch (err) {
                console.error('Error getAlreadyDoneStories', err);
            }

    }, []); // Empty dependency - only run once on mount

    const sleep = (ms) => new Promise(resolve => setTimeout(resolve, ms));

    const getCoordinatesWithRateLimit = async (location) => {
        await sleep(500);
        return getCoordinates(location);
    };


    const getCoordinates = async (location) => {
        if (coordinatesCache[location]) {
            return coordinatesCache[location];
        }
        const token = 'pk.45de83cd128ecaf3975892ad5beff1e1';

        try {
            const response = await axios.get('https://us1.locationiq.com/v1/search', {
                params: {
                    q: location,
                    format: 'json',
                    limit: 1,
                    key: token
                }
            });

            if (response.data && response.data.length > 0) {
                const { lat, lon } = response.data[0];
                const coordinates = [parseFloat(lat), parseFloat(lon)];
                setCoordinatesCache(prevCache => ({
                    ...prevCache,
                    [location]: coordinates
                }));
                return coordinates;
            }
        } catch (error) {
            console.error('Error fetching coordinates:', error);
        }

        return null;
    };

    return (
        <div className="articles-container">
            <div className="stories-content">
                {/* Info banner when backend auto-expanded the time range */}
                {expandedTimeRange && (
                    <div style={{
                        background: '#fff3cd',
                        border: '1px solid #ffc107',
                        borderRadius: '8px',
                        padding: '12px 16px',
                        margin: '0 0 16px 0',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px',
                        fontSize: '14px',
                        color: '#856404'
                    }}>
                        <span style={{ fontSize: '18px' }}>&#9432;</span>
                        <span>
                            No stories found in the selected time range. Showing stories from <strong>{expandedTimeRange}</strong> instead.
                        </span>
                    </div>
                )}
                {/* Removed title and horizontal line */}
                {errorStrories ? (
                        <div>Error: {errorStrories}</div>
                    )
                    : stories.length > 0 && storiesList?.length > 0 ? (
                        <ColumnView
                            key={`column-0`} // Ensure unique key for each ColumnView
                            columnKey={0}
                            articles={storiesList}
                            // handleArticleSelectionChange={handleArticleSelectionChange}
                            // handleClaimSelectionChange={handleClaimsSelectionChange}
                            handleStorySelectionChange={handleExpandStory}
                            selectedArticles={[]}
                            selectedClaims={[]}
                            selectedStories={selectedStories}
                            formatDate={formatDate}
                            // handleAddUrl={handleAddUrl}
                            // translate={translate}
                            dragable={false}
                            hoverable={true}// Example hover color
                            handleMergeStories={canEdit ? handleMergeStories : undefined}
                            animationKey={animationKey}
                            currentStep = {0}
                            alreadyDoneStoriesIds = {alreadyDoneStoriesIds}
                            showToastNotification={showToastNotification}
                            onLoadMore={onLoadMore}
                            hasMore={hasMoreStories}
                            isLoadingMore={isLoadingMore}
                        />
                        // stories.map((story, storyIndex) => renderStory(story, storyIndex))
                    ) : isLoading ? (
                        // Show loader when API call is in progress
                        <div style={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            padding: '100px 20px',
                            minHeight: '400px'
                        }}>
                            <div style={{
                                border: '4px solid #f3f3f3',
                                borderTop: '4px solid #FF6B35',
                                borderRadius: '50%',
                                width: '50px',
                                height: '50px',
                                animation: 'spin 1s linear infinite'
                            }}></div>
                        </div>
                    ) : (
                        // Show "No stories found" only when not loading
                        <div style={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'center',
                            padding: '60px 20px',
                            textAlign: 'center'
                        }}>
                            <img 
                                src="/not-found.svg" 
                                alt="No stories found" 
                                style={{
                                    width: '300px',
                                    height: '300px',
                                    marginBottom: '30px',
                                    opacity: 0.8
                                }}
                            />
                            <h2 style={{
                                color: '#555',
                                fontSize: '28px',
                                marginBottom: '15px',
                                fontWeight: '600'
                            }}>
                                No Stories Found
                            </h2>
                            <p style={{
                                color: '#777',
                                fontSize: '18px',
                                maxWidth: '500px',
                                lineHeight: '1.6'
                            }}>
                                Try changing your search query or{' '}
                                <span 
                                    style={{
                                        color: '#1976d2',
                                        cursor: 'pointer',
                                        textDecoration: 'underline'
                                    }}
                                    onClick={() => window.location.href = '/'}
                                >
                                    reset filters
                                </span>
                                {' '}to see more stories.
                            </p>
                        </div>
                    )}
            </div>
            {/* Toast notification */}
            {showToast && (
                <div style={{
                    position: 'fixed',
                    bottom: '20px',
                    right: '20px',
                    padding: '12px 24px',
                    borderRadius: '8px',
                    backgroundColor: toastType === 'success' ? '#4CAF50' : '#F44336',
                    color: 'white',
                    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.2)',
                    zIndex: 9999,
                    fontSize: '14px',
                    fontWeight: '500',
                    animation: 'fadeIn 0.3s ease'
                }}>
                    {toastMessage}
                </div>
            )}
        </div>
    );
};

export default Stories;
